// Strings added by the market / car details / admin panel redesign.
// Kept in a separate file so the original language.js stays readable; the two
// are merged in language.js, so components still read language[lang].market.x
const languageExtra = {
  geo: {
    common: {
      save: "შენახვა",
      cancel: "გაუქმება",
      close: "დახურვა",
      delete: "წაშლა",
      edit: "რედაქტირება",
      view: "ნახვა",
      confirm: "დადასტურება",
      confirm_title: "დაადასტურეთ მოქმედება",
      search: "ძებნა",
      loading: "იტვირთება...",
      saving: "ინახება...",
      back: "უკან",
      next: "შემდეგი",
      previous: "წინა",
      retry: "თავიდან ცდა",
      clear: "გასუფთავება",
      all: "ყველა",
      yes: "დიახ",
      no: "არა",
      of: "-დან",
      copy: "კოპირება",
      copied: "ბმული დაკოპირდა",
      required_note: "ვარსკვლავით მონიშნული ველები სავალდებულოა",
      unsaved_changes: "თქვენ გაქვთ შეუნახავი ცვლილებები. ნამდვილად გსურთ გვერდის დატოვება?",
      error_title: "დაფიქსირდა შეცდომა",
      error_message: "მონაცემების ჩატვირთვა ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან."
    },
    market: {
      title: "ავტომობილების მარკეტი",
      subtitle: "შეარჩიე ავტომობილი ჩვენი მიმდინარე შეთავაზებებიდან",
      results_found: "ნაპოვნია",
      results_unit: "ავტომობილი",
      filters: "ფილტრები",
      show_filters: "ფილტრების ჩვენება",
      hide_filters: "ფილტრების დამალვა",
      clear_filters: "ფილტრების გასუფთავება",
      apply: "გაფილტვრა",
      search_placeholder: "ძებნა მარკის, მოდელის ან VIN-ის მიხედვით",
      brand: "მარკა",
      model: "მოდელი",
      year_from: "წელი (დან)",
      year_to: "წელი (მდე)",
      price_from: "ფასი (დან)",
      price_to: "ფასი (მდე)",
      mileage_from: "გარბენი (დან)",
      mileage_to: "გარბენი (მდე)",
      fuel: "საწვავი",
      transmission: "გადაცემათა კოლოფი",
      body_type: "ძარის ტიპი",
      drive: "წამყვანი თვლები",
      location: "მდებარეობა",
      status: "სტატუსი",
      status_all: "ყველა",
      status_for_sale: "იყიდება",
      status_sold: "გაყიდულია",
      sort: "დალაგება",
      sort_newest: "ჯერ ახლები",
      sort_oldest: "ჯერ ძველები",
      sort_price_asc: "ფასი: დაბლიდან მაღლა",
      sort_price_desc: "ფასი: მაღლიდან დაბლა",
      sort_mileage_asc: "გარბენი: ზრდადობით",
      sort_mileage_desc: "გარბენი: კლებადობით",
      view_details: "დეტალურად",
      empty_title: "ავტომობილი ვერ მოიძებნა",
      empty_message: "შეცვალეთ ან გაასუფთავეთ ფილტრები და სცადეთ თავიდან.",
      loading: "ავტომობილები იტვირთება...",
      published: "დამატებულია",
      page_of: "გვერდი"
    },
    details: {
      back_to_market: "დაბრუნება მარკეტში",
      overview: "მიმოხილვა",
      description: "აღწერა",
      features: "დამატებითი აღჭურვილობა",
      specifications: "ტექნიკური მახასიათებლები",
      similar_cars: "მსგავსი ავტომობილები",
      contact_seller: "დაგვიკავშირდით",
      request_info: "დაინტერესდი ავტომობილით",
      request_info_text: "დატოვეთ საკონტაქტო ინფორმაცია და ჩვენი მენეჯერი დაგიკავშირდებათ.",
      your_name: "სახელი",
      your_phone: "ტელეფონი",
      your_email: "ელ-ფოსტა",
      your_message: "შეტყობინება",
      send_request: "მოთხოვნის გაგზავნა",
      sending: "იგზავნება...",
      request_sent: "თქვენი მოთხოვნა მიღებულია. მალე დაგიკავშირდებით.",
      call_now: "დარეკვა",
      published_at: "გამოქვეყნების თარიღი",
      lot: "ლოტის ნომერი",
      auction: "აუქციონი",
      currency: "ვალუტა",
      no_images: "ფოტოები არ არის ატვირთული",
      not_found_title: "ავტომობილი ვერ მოიძებნა",
      not_found_message: "მოთხოვნილი ავტომობილი აღარ არის ხელმისაწვდომი ან წაშლილია.",
      photo_of: "ფოტო",
      open_gallery: "გალერეის გახსნა",
      close_gallery: "გალერეის დახურვა",
      prev_photo: "წინა ფოტო",
      next_photo: "შემდეგი ფოტო"
    },
    admin: {
      panel: "ადმინ პანელი",
      dashboard: "მთავარი",
      cars: "ავტომობილები",
      leads: "ლიდები",
      messages: "შეტყობინებები",
      back_to_site: "საიტზე დაბრუნება",
      access_denied_title: "წვდომა შეზღუდულია",
      access_denied_message: "ამ გვერდის სანახავად საჭიროა ავტორიზაცია.",
      login: "შესვლა",
      cars_title: "ავტომობილების მართვა",
      cars_subtitle: "დაამატეთ, დაარედაქტირეთ და მართეთ მარკეტის ავტომობილები",
      add_car: "ავტომობილის დამატება",
      edit_car: "ავტომობილის რედაქტირება",
      search_cars: "ძებნა მარკის, მოდელის ან VIN-ის მიხედვით",
      table_photo: "ფოტო",
      table_car: "ავტომობილი",
      table_vin: "VIN",
      table_year: "წელი",
      table_price: "ფასი",
      table_mileage: "გარბენი",
      table_location: "მდებარეობა",
      table_status: "სტატუსი",
      table_date: "თარიღი",
      table_actions: "მოქმედებები",
      mark_as_sold: "მონიშნე გაყიდულად",
      mark_as_for_sale: "მონიშნე იყიდებად",
      manage_images: "ფოტოების მართვა",
      delete_car_title: "ავტომობილის წაშლა",
      delete_car_message: "ნამდვილად გსურთ ამ ავტომობილის წაშლა? მოქმედება შეუქცევადია.",
      no_cars_title: "ავტომობილები არ არის",
      no_cars_message: "დაამატეთ პირველი ავტომობილი მარკეტში გამოსაჩენად.",
      car_created: "ავტომობილი წარმატებით დაემატა",
      car_updated: "ავტომობილი წარმატებით განახლდა",
      car_deleted: "ავტომობილი წაიშალა",
      status_changed: "სტატუსი შეიცვალა"
    },
    carForm: {
      step_basic: "ძირითადი ინფორმაცია",
      step_technical: "ტექნიკური მახასიათებლები",
      step_price: "ფასი და სტატუსი",
      step_description: "აღწერა და აღჭურვილობა",
      step_images: "ფოტოები",
      step_review: "გადამოწმება",
      vin: "VIN კოდი",
      vin_hint: "17 სიმბოლო. Enter-ზე ავტომატურად შეივსება მონაცემები.",
      decode_vin: "VIN-ის დეკოდირება",
      vin_decoded: "VIN-ის მონაცემები ჩაიტვირთა",
      vin_decode_failed: "VIN-ის დეკოდირება ვერ მოხერხდა",
      mark: "მარკა",
      model: "მოდელი",
      year: "გამოშვების წელი",
      lot: "ლოტის ნომერი",
      auction: "აუქციონი",
      price: "ფასი",
      currency: "ვალუტა",
      phone: "საკონტაქტო ტელეფონი",
      location: "მდებარეობა",
      category: "ძარის ტიპი",
      millage: "გარბენი (კმ)",
      fuel: "საწვავის ტიპი",
      engine: "ძრავის მოცულობა",
      cilinder: "ცილინდრები",
      transmission: "გადაცემათა კოლოფი",
      drive: "წამყვანი თვლები",
      doors: "კარები",
      airbags: "აირბეგები",
      color: "ფერი",
      description: "აღწერა",
      description_placeholder: "დაწერეთ ავტომობილის შესახებ დამატებითი ინფორმაცია",
      features: "აღჭურვილობა",
      features_placeholder: "დაამატეთ აღჭურვილობა და დააჭირეთ Enter",
      add_feature: "დამატება",
      images: "ფოტოები",
      choose_files: "აირჩიეთ ფოტოები",
      drop_hint: "JPG, PNG, WEBP ან AVIF — მაქსიმუმ 10 MB თითო ფოტოზე",
      upload: "ატვირთვა",
      uploading: "იტვირთება...",
      set_cover: "მთავარი ფოტო",
      cover: "მთავარი",
      move_left: "გადატანა მარცხნივ",
      move_right: "გადატანა მარჯვნივ",
      remove_image: "ფოტოს წაშლა",
      delete_image_title: "ფოტოს წაშლა",
      delete_image_message: "ნამდვილად გსურთ ამ ფოტოს წაშლა?",
      images_uploaded: "ფოტოები აიტვირთა",
      image_removed: "ფოტო წაიშალა",
      gallery_updated: "გალერეა განახლდა",
      pending_images: "ასატვირთი ფოტოები",
      saved_images: "შენახული ფოტოები",
      no_images_yet: "ფოტოები ჯერ არ არის დამატებული",
      select_placeholder: "აირჩიეთ",
      invalid_type: "დაშვებულია მხოლოდ JPG, PNG, WEBP, AVIF და GIF ფორმატები",
      too_large: "ფაილი აღემატება 10 MB-ს",
      too_many: "ერთდროულად შეგიძლიათ ატვირთოთ მაქსიმუმ 30 ფოტო",
      fix_errors: "გთხოვთ შეავსოთ ყველა სავალდებულო ველი",
      save_car: "ავტომობილის შენახვა",
      save_and_continue: "შენახვა და გაგრძელება",
      finish: "დასრულება"
    },
    leads: {
      title: "ლიდები და მოთხოვნები",
      subtitle: "მომხმარებლების მიერ გამოგზავნილი განაცხადები",
      search_placeholder: "ძებნა სახელით, ტელეფონით ან ელ-ფოსტით",
      table_client: "კლიენტი",
      table_contact: "კონტაქტი",
      table_source: "წყარო",
      table_car: "ავტომობილი",
      table_status: "სტატუსი",
      table_date: "თარიღი",
      table_actions: "მოქმედებები",
      status_new: "ახალი",
      status_contacted: "დაკავშირებული",
      status_qualified: "კვალიფიცირებული",
      status_closed: "დახურული",
      status_rejected: "უარყოფილი",
      source_home_form: "მთავარი გვერდი",
      source_contact_form: "საკონტაქტო ფორმა",
      source_car_enquiry: "ავტომობილის მოთხოვნა",
      source_callback: "ზარის მოთხოვნა",
      source_subscribe: "გამოწერა",
      source_other: "სხვა",
      filter_status: "სტატუსი",
      filter_source: "წყარო",
      filter_date_from: "თარიღიდან",
      filter_date_to: "თარიღამდე",
      details_title: "ლიდის დეტალები",
      client_type: "კლიენტის ტიპი",
      est_amount: "სავარაუდო ბიუჯეტი",
      manufacturer: "სასურველი მარკა",
      message: "შეტყობინება",
      subject: "თემა",
      admin_note: "შიდა შენიშვნა",
      admin_note_placeholder: "დაამატეთ შენიშვნა ამ ლიდზე",
      save_note: "შენიშვნის შენახვა",
      change_status: "სტატუსის შეცვლა",
      open_car: "ავტომობილის ნახვა",
      created_at: "შექმნის თარიღი",
      updated_at: "განახლების თარიღი",
      no_leads_title: "ლიდები არ არის",
      no_leads_message: "ახალი მოთხოვნები აქ გამოჩნდება.",
      delete_title: "ლიდის წაშლა",
      delete_message: "ნამდვილად გსურთ ამ ლიდის წაშლა? მოქმედება შეუქცევადია.",
      status_updated: "სტატუსი განახლდა",
      note_updated: "შენიშვნა შენახულია",
      lead_deleted: "ლიდი წაიშალა"
    },
    // Merged into the existing home_page section by language.js.
    home_page: {
      about_us_title: "ქარექსპრესის შესახებ",
      latest_cars: "ბოლოს დამატებული ავტომობილები",
      latest_cars_subtitle: "ჩვენს მარკეტში უკვე ხელმისაწვდომი ავტომობილები",
      view_all_cars: "ყველა ავტომობილი",
      hero: {
        title_line1: "შეარჩიე შენი",
        title_accent: "ავტომობილი",
        subtitle: "ჩვენ ვიპოვით, შევამოწმებთ და ჩამოგიყვანთ შენთვის სასურველ ავტომობილს აშშ-დან, კანადიდან და ევროპიდან",
        feature_experience: "20+ წლიანი გამოცდილება",
        feature_imported: "15,000+ წარმატებით ჩამოყვანილი ავტომობილი",
        feature_history: "შესამოწმებელი ავტომობილების სრული ისტორია",
        feature_support: "სრული მხარდაჭერა აუქციონიდან რეგისტრაციამდე",
        view_cars: "იხილეთ ავტომობილები",
        form_title: "შეავსე განაცხადი",
        form_subtitle: "ჩვენი სპეციალისტი უმოკლეს დროში დაგიკავშირდება",
        purpose_label: "რა მიზნით გსურს ავტომობილის ჩამოყვანა?",
        purpose_personal: "პირადი მოხმარებისთვის",
        purpose_dealer: "დილერი ვარ",
        price_label: "რა საფასო კატეგორიაში ეძებ ავტომობილს?",
        price_3_full: "$18,000-ზე მეტი",
        price_3_short: "$18K-ზე მეტი",
        make_label: "რომელი მარკის ავტომობილი გაინტერესებს?",
        make_placeholder: "აირჩიე სასურველი მარკა",
        ph_name: "სახელი",
        ph_surname: "გვარი",
        ph_phone: "ტელ. ნომერი",
        ph_email: "ელ.ფოსტა",
        ph_comment: "კომენტარი",
        agree: "თანახმა ვარ პერსონალური მონაცემების დამუშავებაზე",
        submit: "გაგზავნა",
        submitting: "...იგზავნება",
        agree_required: "გთხოვთ განაცხადოთ თანხმობა პერსონალური მონაცემების დამუშავებაზე",
        request_sent: "თქვენი მოთხოვნა გაგზავნილია",
        request_failed: "დაფიქსირდა შეცდომა. სცადეთ თავიდან."
      }
    },
    about: {
      eyebrow: "Car Auto Import Express",
      title: "ჩვენს შესახებ",
      subtitle: "20 წელზე მეტი გამოცდილება ავტომობილების, სპეც-ტექნიკისა და ავტონაწილების იმპორტში აშშ-დან, კანადიდან და ევროპიდან.",
      stats: [
        {value: "20+", label: "წელი ბაზარზე"},
        {value: "200 000+", label: "იმპორტირებული ავტომობილი"},
        {value: "30", label: "ფილიალი საქართველოში"},
        {value: "10", label: "წარმომადგენლობა საზღვარგარეთ"}
      ],
      story_title: "ვინ ვართ ჩვენ",
      offers_title: "რას გთავაზობთ",
      market_title: "ჩვენი ავტო-მარკეტი",
      vehicles_title: "რას ვაზიდავთ",
      offers: [
        "შეუზღუდავი არჩევანი მსოფლიოს წამყვან აუქციონებსა და სადილერო მარკეტებზე",
        "ავტომობილის შეძენა საუკეთესო ფასად",
        "უსაფრთხო და სწრაფი ტრანსპორტირება",
        "მოქნილი, ინდივიდუალურად მორგებული თანადაფინანსება",
        "პასუხისმგებლობა ავტომობილის დაზიანებაზე",
        "ტრანსპორტირება შეძენის ადგილიდან სასურველ პუნქტამდე",
        "დახმარება ავტომობილის რეალიზაციაში",
        "სატერმინალო მომსახურება"
      ],
      cta_title: "მზად ხართ ავტომობილის ჩამოსაყვანად?",
      cta_text: "დაგვიკავშირდით და ჩვენი მენეჯერი დაგეხმარებათ სასურველი ავტომობილის შერჩევაში.",
      cta_button: "დაგვიკავშირდით",
      browse_cars: "ავტომობილების ნახვა"
    },
    services: {
      eyebrow: "Car Auto Import Express",
      subtitle: "საზღვაო, საჰაერო და სპეციალური გადაზიდვები — ერთი გუნდი აუქციონიდან თქვენს ეზომდე.",
      sea_description: "კონტეინერული და RoRo გადაზიდვა აშშ-ის, კანადისა და ევროპის პორტებიდან.",
      air_description: "სასწრაფო ავიაგადაზიდვა, როცა ავტომობილი ან ნაწილები დროულად გჭირდებათ.",
      yacht_description: "იახტების, კატერებისა და წყლის ტრანსპორტის უსაფრთხო ტრანსპორტირება.",
      process_title: "როგორ მუშაობს",
      steps: [
        {title: "შერჩევა", text: "თქვენს ბიუჯეტსა და მოთხოვნებზე მორგებულ ავტომობილს ვეძებთ მსოფლიოს წამყვან აუქციონებზე."},
        {title: "შეძენა", text: "ვაჭრობაში ვმონაწილეობთ თქვენი სახელით და ვყიდულობთ საუკეთესო ფასად."},
        {title: "ტრანსპორტირება", text: "ვახორციელებთ საზღვაო ან საჰაერო გადაზიდვას და გატყობინებთ თითოეულ ეტაპს."},
        {title: "ჩაბარება", text: "სატერმინალო მომსახურება და ავტომობილის ჩაბარება თქვენთვის სასურველ ლოკაციაზე."}
      ],
      extras_title: "დამატებითი სერვისები",
      extras: [
        "სატერმინალო მომსახურება",
        "თანადაფინანსება",
        "ავტომობილის ისტორიის შემოწმება",
        "დახმარება რეალიზაციაში",
        "ავტონაწილებისა და აქსესუარების იმპორტი",
        "სპეც-ტექნიკის იმპორტი"
      ],
      cta_text: "მოგვწერეთ ან დაგვირეკეთ — გაგიწევთ კონსულტაციას და გამოგითვლით სრულ ღირებულებას.",
      cta_button: "დაგვიკავშირდით"
    },
    contactPage: {
      eyebrow: "Car Auto Import Express",
      title: "კონტაქტი",
      subtitle: "დაგვირეკეთ, მოგვწერეთ ან ეწვიეთ ჩვენს ოფისს — ყოველთვის მზად ვართ დაგეხმაროთ.",
      form_note: "შეავსეთ ფორმა და ჩვენი მენეჯერი დაგიკავშირდებათ სამუშაო საათებში.",
      channels_title: "სწრაფი კავშირი",
      call_button: "დარეკვა",
      whatsapp_button: "WhatsApp-ით მოწერა",
      email_button: "ელ-ფოსტის გაგზავნა",
      open_map: "რუკაზე ნახვა"
    }
  },

  en: {
    common: {
      save: "Save", cancel: "Cancel", close: "Close", delete: "Delete", edit: "Edit", view: "View",
      confirm: "Confirm", confirm_title: "Please confirm", search: "Search", loading: "Loading...",
      saving: "Saving...", back: "Back", next: "Next", previous: "Previous", retry: "Try again",
      clear: "Clear", all: "All", yes: "Yes", no: "No", of: "of", copy: "Copy",
      copied: "Link copied to clipboard",
      required_note: "Fields marked with an asterisk are required",
      unsaved_changes: "You have unsaved changes. Leave this page?",
      error_title: "Something went wrong",
      error_message: "We could not load the data. Please try again."
    },
    market: {
      title: "Car Market",
      subtitle: "Pick your car from our current stock",
      results_found: "Found", results_unit: "cars",
      filters: "Filters", show_filters: "Show filters", hide_filters: "Hide filters",
      clear_filters: "Clear filters", apply: "Apply",
      search_placeholder: "Search by make, model or VIN",
      brand: "Make", model: "Model", year_from: "Year from", year_to: "Year to",
      price_from: "Price from", price_to: "Price to",
      mileage_from: "Mileage from", mileage_to: "Mileage to",
      fuel: "Fuel", transmission: "Transmission", body_type: "Body type",
      drive: "Drive", location: "Location", status: "Status",
      status_all: "All", status_for_sale: "For sale", status_sold: "Sold",
      sort: "Sort by",
      sort_newest: "Newest first", sort_oldest: "Oldest first",
      sort_price_asc: "Price: low to high", sort_price_desc: "Price: high to low",
      sort_mileage_asc: "Mileage: low to high", sort_mileage_desc: "Mileage: high to low",
      view_details: "View details",
      empty_title: "No cars found",
      empty_message: "Try changing or clearing the filters.",
      loading: "Loading cars...",
      published: "Added",
      page_of: "Page"
    },
    details: {
      back_to_market: "Back to market",
      overview: "Overview", description: "Description", features: "Features",
      specifications: "Specifications", similar_cars: "Similar cars",
      contact_seller: "Contact us", request_info: "Interested in this car?",
      request_info_text: "Leave your contact details and our manager will get back to you.",
      your_name: "Name", your_phone: "Phone", your_email: "Email", your_message: "Message",
      send_request: "Send request", sending: "Sending...",
      request_sent: "Your request has been received. We will contact you shortly.",
      call_now: "Call now", published_at: "Published", lot: "Lot number", auction: "Auction",
      currency: "Currency", no_images: "No photos uploaded",
      not_found_title: "Car not found",
      not_found_message: "This car is no longer available or has been removed.",
      photo_of: "Photo", open_gallery: "Open gallery", close_gallery: "Close gallery",
      prev_photo: "Previous photo", next_photo: "Next photo"
    },
    admin: {
      panel: "Admin panel", dashboard: "Dashboard", cars: "Cars", leads: "Leads",
      messages: "Messages", back_to_site: "Back to site",
      access_denied_title: "Access restricted",
      access_denied_message: "You need to sign in to view this page.",
      login: "Sign in",
      cars_title: "Car management",
      cars_subtitle: "Add, edit and manage the cars shown on the market",
      add_car: "Add car", edit_car: "Edit car",
      search_cars: "Search by make, model or VIN",
      table_photo: "Photo", table_car: "Car", table_vin: "VIN", table_year: "Year",
      table_price: "Price", table_mileage: "Mileage", table_location: "Location",
      table_status: "Status", table_date: "Date", table_actions: "Actions",
      mark_as_sold: "Mark as sold", mark_as_for_sale: "Mark as for sale",
      manage_images: "Manage photos",
      delete_car_title: "Delete car",
      delete_car_message: "Delete this car permanently? This cannot be undone.",
      no_cars_title: "No cars yet",
      no_cars_message: "Add your first car to show it on the market.",
      car_created: "Car created successfully",
      car_updated: "Car updated successfully",
      car_deleted: "Car deleted",
      status_changed: "Status changed"
    },
    carForm: {
      step_basic: "Basic information", step_technical: "Technical specs",
      step_price: "Price & status", step_description: "Description & features",
      step_images: "Photos", step_review: "Review",
      vin: "VIN", vin_hint: "17 characters. Press Enter to auto-fill the details.",
      decode_vin: "Decode VIN", vin_decoded: "VIN details loaded",
      vin_decode_failed: "Could not decode this VIN",
      mark: "Make", model: "Model", year: "Year", lot: "Lot number", auction: "Auction",
      price: "Price", currency: "Currency", phone: "Contact phone", location: "Location",
      category: "Body type", millage: "Mileage (km)", fuel: "Fuel type",
      engine: "Engine size", cilinder: "Cylinders", transmission: "Transmission",
      drive: "Drive", doors: "Doors", airbags: "Airbags", color: "Color",
      description: "Description",
      description_placeholder: "Add any extra information about this car",
      features: "Features", features_placeholder: "Type a feature and press Enter",
      add_feature: "Add",
      images: "Photos", choose_files: "Choose photos",
      drop_hint: "JPG, PNG, WEBP or AVIF — up to 10 MB each",
      upload: "Upload", uploading: "Uploading...",
      set_cover: "Set as cover", cover: "Cover",
      move_left: "Move left", move_right: "Move right", remove_image: "Remove photo",
      delete_image_title: "Delete photo",
      delete_image_message: "Delete this photo permanently?",
      images_uploaded: "Photos uploaded", image_removed: "Photo removed",
      gallery_updated: "Gallery updated",
      pending_images: "Ready to upload", saved_images: "Saved photos",
      no_images_yet: "No photos added yet",
      select_placeholder: "Select",
      invalid_type: "Only JPG, PNG, WEBP, AVIF and GIF files are allowed",
      too_large: "This file is larger than 10 MB",
      too_many: "You can upload up to 30 photos at once",
      fix_errors: "Please fill in all required fields",
      save_car: "Save car", save_and_continue: "Save and continue", finish: "Finish"
    },
    leads: {
      title: "Leads & requests",
      subtitle: "Enquiries submitted by visitors",
      search_placeholder: "Search by name, phone or email",
      table_client: "Client", table_contact: "Contact", table_source: "Source",
      table_car: "Car", table_status: "Status", table_date: "Date", table_actions: "Actions",
      status_new: "New", status_contacted: "Contacted", status_qualified: "Qualified",
      status_closed: "Closed", status_rejected: "Rejected",
      source_home_form: "Home page", source_contact_form: "Contact form",
      source_car_enquiry: "Car enquiry", source_callback: "Callback",
      source_subscribe: "Subscription", source_other: "Other",
      filter_status: "Status", filter_source: "Source",
      filter_date_from: "From date", filter_date_to: "To date",
      details_title: "Lead details",
      client_type: "Client type", est_amount: "Estimated budget",
      manufacturer: "Preferred make", message: "Message", subject: "Subject",
      admin_note: "Internal note", admin_note_placeholder: "Add a note about this lead",
      save_note: "Save note", change_status: "Change status", open_car: "Open car",
      created_at: "Created", updated_at: "Updated",
      no_leads_title: "No leads yet",
      no_leads_message: "New enquiries will appear here.",
      delete_title: "Delete lead",
      delete_message: "Delete this lead permanently? This cannot be undone.",
      status_updated: "Status updated", note_updated: "Note saved", lead_deleted: "Lead deleted"
    },
    home_page: {
      about_us_title: "About Carexpress",
      latest_cars: "Latest cars",
      latest_cars_subtitle: "Vehicles already available in our market",
      view_all_cars: "All cars",
      hero: {
        title_line1: "Choose your",
        title_accent: "car",
        subtitle: "We will find, inspect and deliver the car you want from the USA, Canada and Europe",
        feature_experience: "20+ years of experience",
        feature_imported: "15,000+ cars successfully delivered",
        feature_history: "Full history of every car we inspect",
        feature_support: "Full support from auction to registration",
        view_cars: "View cars",
        form_title: "Submit a request",
        form_subtitle: "Our specialist will contact you shortly",
        purpose_label: "Why do you want to import a car?",
        purpose_personal: "For personal use",
        purpose_dealer: "I am a dealer",
        price_label: "What price range are you looking in?",
        price_3_full: "Over $18,000",
        price_3_short: "$18K+",
        make_label: "Which car make are you interested in?",
        make_placeholder: "Choose a make",
        ph_name: "Name",
        ph_surname: "Surname",
        ph_phone: "Phone number",
        ph_email: "Email",
        ph_comment: "Comment",
        agree: "I agree to the processing of personal data",
        submit: "Send",
        submitting: "Sending...",
        agree_required: "Please agree to the processing of personal data",
        request_sent: "Your request has been sent",
        request_failed: "Something went wrong. Please try again."
      }
    },
    about: {
      eyebrow: "Car Auto Import Express",
      title: "About Us",
      subtitle: "Over 20 years of importing vehicles, special equipment and auto parts from the USA, Canada and Europe.",
      stats: [
        {value: "20+", label: "years on the market"},
        {value: "200,000+", label: "vehicles imported"},
        {value: "30", label: "branches across Georgia"},
        {value: "10", label: "representations abroad"}
      ],
      story_title: "Who we are",
      offers_title: "What we offer",
      market_title: "Our auto market",
      vehicles_title: "What we ship",
      offers: [
        "Unlimited selection from leading auctions and dealer markets worldwide",
        "Buying your car at the best possible price",
        "Safe and fast transportation",
        "Flexible, individually tailored co-financing",
        "Liability for damage to the vehicle",
        "Delivery from the point of purchase to your chosen destination",
        "Assistance with reselling the vehicle",
        "Terminal services"
      ],
      cta_title: "Ready to import your car?",
      cta_text: "Get in touch and our manager will help you pick the right vehicle.",
      cta_button: "Contact us",
      browse_cars: "Browse cars"
    },
    services: {
      eyebrow: "Car Auto Import Express",
      subtitle: "Sea, air and special freight — one team from the auction to your driveway.",
      sea_description: "Container and RoRo shipping from ports in the USA, Canada and Europe.",
      air_description: "Express air freight when you need the car or the parts fast.",
      yacht_description: "Safe transportation of yachts, boats and other watercraft.",
      process_title: "How it works",
      steps: [
        {title: "Selection", text: "We search the world's leading auctions for a car that fits your budget and requirements."},
        {title: "Purchase", text: "We bid on your behalf and buy the vehicle at the best price."},
        {title: "Shipping", text: "We arrange sea or air freight and keep you posted at every stage."},
        {title: "Delivery", text: "Terminal services and hand-over of the car at the location you choose."}
      ],
      extras_title: "Additional services",
      extras: [
        "Terminal services",
        "Co-financing",
        "Vehicle history check",
        "Help with reselling",
        "Import of auto parts and accessories",
        "Import of special equipment"
      ],
      cta_text: "Write or call us — we will advise you and calculate the full cost.",
      cta_button: "Contact us"
    },
    contactPage: {
      eyebrow: "Car Auto Import Express",
      title: "Contact",
      subtitle: "Call us, write to us or visit our office — we are always happy to help.",
      form_note: "Fill in the form and our manager will get back to you during working hours.",
      channels_title: "Quick contact",
      call_button: "Call us",
      whatsapp_button: "Message on WhatsApp",
      email_button: "Send an email",
      open_map: "Open in maps"
    }
  },

  ru: {
    common: {
      save: "Сохранить", cancel: "Отмена", close: "Закрыть", delete: "Удалить",
      edit: "Редактировать", view: "Просмотр", confirm: "Подтвердить",
      confirm_title: "Подтвердите действие", search: "Поиск", loading: "Загрузка...",
      saving: "Сохранение...", back: "Назад", next: "Далее", previous: "Назад",
      retry: "Повторить", clear: "Очистить", all: "Все", yes: "Да", no: "Нет",
      of: "из", copy: "Копировать", copied: "Ссылка скопирована",
      required_note: "Поля со звёздочкой обязательны",
      unsaved_changes: "Есть несохранённые изменения. Покинуть страницу?",
      error_title: "Произошла ошибка",
      error_message: "Не удалось загрузить данные. Попробуйте ещё раз."
    },
    market: {
      title: "Автомобильный рынок",
      subtitle: "Выберите автомобиль из нашего текущего предложения",
      results_found: "Найдено", results_unit: "автомобилей",
      filters: "Фильтры", show_filters: "Показать фильтры", hide_filters: "Скрыть фильтры",
      clear_filters: "Очистить фильтры", apply: "Применить",
      search_placeholder: "Поиск по марке, модели или VIN",
      brand: "Марка", model: "Модель", year_from: "Год от", year_to: "Год до",
      price_from: "Цена от", price_to: "Цена до",
      mileage_from: "Пробег от", mileage_to: "Пробег до",
      fuel: "Топливо", transmission: "Коробка передач", body_type: "Тип кузова",
      drive: "Привод", location: "Местоположение", status: "Статус",
      status_all: "Все", status_for_sale: "В продаже", status_sold: "Продано",
      sort: "Сортировка",
      sort_newest: "Сначала новые", sort_oldest: "Сначала старые",
      sort_price_asc: "Цена: по возрастанию", sort_price_desc: "Цена: по убыванию",
      sort_mileage_asc: "Пробег: по возрастанию", sort_mileage_desc: "Пробег: по убыванию",
      view_details: "Подробнее",
      empty_title: "Автомобили не найдены",
      empty_message: "Измените или очистите фильтры и попробуйте снова.",
      loading: "Загрузка автомобилей...",
      published: "Добавлено",
      page_of: "Страница"
    },
    details: {
      back_to_market: "Назад в маркет",
      overview: "Обзор", description: "Описание", features: "Комплектация",
      specifications: "Характеристики", similar_cars: "Похожие автомобили",
      contact_seller: "Свяжитесь с нами", request_info: "Заинтересовал автомобиль?",
      request_info_text: "Оставьте контакты, и наш менеджер свяжется с вами.",
      your_name: "Имя", your_phone: "Телефон", your_email: "Email", your_message: "Сообщение",
      send_request: "Отправить заявку", sending: "Отправка...",
      request_sent: "Ваша заявка принята. Мы скоро свяжемся с вами.",
      call_now: "Позвонить", published_at: "Опубликовано", lot: "Номер лота",
      auction: "Аукцион", currency: "Валюта", no_images: "Фотографии не загружены",
      not_found_title: "Автомобиль не найден",
      not_found_message: "Этот автомобиль больше не доступен или был удалён.",
      photo_of: "Фото", open_gallery: "Открыть галерею", close_gallery: "Закрыть галерею",
      prev_photo: "Предыдущее фото", next_photo: "Следующее фото"
    },
    admin: {
      panel: "Админ-панель", dashboard: "Главная", cars: "Автомобили", leads: "Заявки",
      messages: "Сообщения", back_to_site: "Вернуться на сайт",
      access_denied_title: "Доступ ограничен",
      access_denied_message: "Для просмотра этой страницы нужно войти в систему.",
      login: "Войти",
      cars_title: "Управление автомобилями",
      cars_subtitle: "Добавляйте и редактируйте автомобили на маркете",
      add_car: "Добавить автомобиль", edit_car: "Редактировать автомобиль",
      search_cars: "Поиск по марке, модели или VIN",
      table_photo: "Фото", table_car: "Автомобиль", table_vin: "VIN", table_year: "Год",
      table_price: "Цена", table_mileage: "Пробег", table_location: "Местоположение",
      table_status: "Статус", table_date: "Дата", table_actions: "Действия",
      mark_as_sold: "Отметить проданным", mark_as_for_sale: "Отметить в продаже",
      manage_images: "Управление фото",
      delete_car_title: "Удаление автомобиля",
      delete_car_message: "Удалить этот автомобиль? Действие необратимо.",
      no_cars_title: "Автомобилей пока нет",
      no_cars_message: "Добавьте первый автомобиль, чтобы он появился на маркете.",
      car_created: "Автомобиль успешно добавлен",
      car_updated: "Автомобиль успешно обновлён",
      car_deleted: "Автомобиль удалён",
      status_changed: "Статус изменён"
    },
    carForm: {
      step_basic: "Основная информация", step_technical: "Технические характеристики",
      step_price: "Цена и статус", step_description: "Описание и комплектация",
      step_images: "Фотографии", step_review: "Проверка",
      vin: "VIN", vin_hint: "17 символов. Нажмите Enter для автозаполнения.",
      decode_vin: "Расшифровать VIN", vin_decoded: "Данные VIN загружены",
      vin_decode_failed: "Не удалось расшифровать VIN",
      mark: "Марка", model: "Модель", year: "Год выпуска", lot: "Номер лота",
      auction: "Аукцион", price: "Цена", currency: "Валюта", phone: "Контактный телефон",
      location: "Местоположение", category: "Тип кузова", millage: "Пробег (км)",
      fuel: "Тип топлива", engine: "Объём двигателя", cilinder: "Цилиндры",
      transmission: "Коробка передач", drive: "Привод", doors: "Двери",
      airbags: "Подушки безопасности", color: "Цвет",
      description: "Описание",
      description_placeholder: "Добавьте дополнительную информацию об автомобиле",
      features: "Комплектация", features_placeholder: "Введите опцию и нажмите Enter",
      add_feature: "Добавить",
      images: "Фотографии", choose_files: "Выбрать фото",
      drop_hint: "JPG, PNG, WEBP или AVIF — до 10 МБ каждое",
      upload: "Загрузить", uploading: "Загрузка...",
      set_cover: "Сделать главным", cover: "Главное",
      move_left: "Влево", move_right: "Вправо", remove_image: "Удалить фото",
      delete_image_title: "Удаление фото",
      delete_image_message: "Удалить это фото безвозвратно?",
      images_uploaded: "Фотографии загружены", image_removed: "Фото удалено",
      gallery_updated: "Галерея обновлена",
      pending_images: "Готовы к загрузке", saved_images: "Сохранённые фото",
      no_images_yet: "Фотографии ещё не добавлены",
      select_placeholder: "Выберите",
      invalid_type: "Разрешены только JPG, PNG, WEBP, AVIF и GIF",
      too_large: "Файл больше 10 МБ",
      too_many: "За один раз можно загрузить не более 30 фотографий",
      fix_errors: "Пожалуйста, заполните все обязательные поля",
      save_car: "Сохранить автомобиль", save_and_continue: "Сохранить и продолжить",
      finish: "Завершить"
    },
    leads: {
      title: "Заявки и обращения",
      subtitle: "Обращения, отправленные посетителями сайта",
      search_placeholder: "Поиск по имени, телефону или email",
      table_client: "Клиент", table_contact: "Контакты", table_source: "Источник",
      table_car: "Автомобиль", table_status: "Статус", table_date: "Дата",
      table_actions: "Действия",
      status_new: "Новая", status_contacted: "Связались", status_qualified: "Квалифицирована",
      status_closed: "Закрыта", status_rejected: "Отклонена",
      source_home_form: "Главная страница", source_contact_form: "Форма контактов",
      source_car_enquiry: "Запрос по автомобилю", source_callback: "Обратный звонок",
      source_subscribe: "Подписка", source_other: "Другое",
      filter_status: "Статус", filter_source: "Источник",
      filter_date_from: "Дата с", filter_date_to: "Дата по",
      details_title: "Детали заявки",
      client_type: "Тип клиента", est_amount: "Ориентировочный бюджет",
      manufacturer: "Желаемая марка", message: "Сообщение", subject: "Тема",
      admin_note: "Внутренняя заметка", admin_note_placeholder: "Добавьте заметку по заявке",
      save_note: "Сохранить заметку", change_status: "Изменить статус",
      open_car: "Открыть автомобиль", created_at: "Создана", updated_at: "Обновлена",
      no_leads_title: "Заявок пока нет",
      no_leads_message: "Новые обращения появятся здесь.",
      delete_title: "Удаление заявки",
      delete_message: "Удалить эту заявку безвозвратно?",
      status_updated: "Статус обновлён", note_updated: "Заметка сохранена",
      lead_deleted: "Заявка удалена"
    },
    home_page: {
      about_us_title: "О компании Carexpress",
      latest_cars: "Последние автомобили",
      latest_cars_subtitle: "Автомобили, уже доступные в нашем маркете",
      view_all_cars: "Все автомобили",
      hero: {
        title_line1: "Выберите свой",
        title_accent: "автомобиль",
        subtitle: "Мы найдём, проверим и пригоним нужный вам автомобиль из США, Канады и Европы",
        feature_experience: "20+ лет опыта",
        feature_imported: "15 000+ успешно пригнанных автомобилей",
        feature_history: "Полная история каждого проверяемого автомобиля",
        feature_support: "Полное сопровождение от аукциона до регистрации",
        view_cars: "Смотреть автомобили",
        form_title: "Оставьте заявку",
        form_subtitle: "Наш специалист свяжется с вами в ближайшее время",
        purpose_label: "С какой целью хотите пригнать автомобиль?",
        purpose_personal: "Для личного пользования",
        purpose_dealer: "Я дилер",
        price_label: "В какой ценовой категории ищете автомобиль?",
        price_3_full: "Более $18,000",
        price_3_short: "$18K+",
        make_label: "Какая марка автомобиля вас интересует?",
        make_placeholder: "Выберите марку",
        ph_name: "Имя",
        ph_surname: "Фамилия",
        ph_phone: "Тел. номер",
        ph_email: "Эл. почта",
        ph_comment: "Комментарий",
        agree: "Согласен на обработку персональных данных",
        submit: "Отправить",
        submitting: "Отправка...",
        agree_required: "Пожалуйста, подтвердите согласие на обработку персональных данных",
        request_sent: "Ваша заявка отправлена",
        request_failed: "Произошла ошибка. Попробуйте ещё раз."
      }
    },
    about: {
      eyebrow: "Car Auto Import Express",
      title: "О нас",
      subtitle: "Более 20 лет импортируем автомобили, спецтехнику и автозапчасти из США, Канады и Европы.",
      stats: [
        {value: "20+", label: "лет на рынке"},
        {value: "200 000+", label: "импортированных автомобилей"},
        {value: "30", label: "филиалов по Грузии"},
        {value: "10", label: "представительств за рубежом"}
      ],
      story_title: "Кто мы",
      offers_title: "Что мы предлагаем",
      market_title: "Наш автомаркет",
      vehicles_title: "Что мы перевозим",
      offers: [
        "Неограниченный выбор на ведущих аукционах и дилерских рынках мира",
        "Покупка автомобиля по лучшей цене",
        "Безопасная и быстрая транспортировка",
        "Гибкие и индивидуальные условия софинансирования",
        "Ответственность за повреждение автомобиля",
        "Доставка от места покупки до желаемого пункта",
        "Помощь в продаже автомобиля",
        "Терминальные услуги"
      ],
      cta_title: "Готовы пригнать автомобиль?",
      cta_text: "Свяжитесь с нами — наш менеджер поможет подобрать подходящий автомобиль.",
      cta_button: "Связаться с нами",
      browse_cars: "Смотреть автомобили"
    },
    services: {
      eyebrow: "Car Auto Import Express",
      subtitle: "Морские, авиа и специальные перевозки — одна команда от аукциона до вашего двора.",
      sea_description: "Контейнерные и RoRo перевозки из портов США, Канады и Европы.",
      air_description: "Срочная авиадоставка, когда автомобиль или запчасти нужны быстро.",
      yacht_description: "Безопасная перевозка яхт, катеров и другого водного транспорта.",
      process_title: "Как это работает",
      steps: [
        {title: "Подбор", text: "Ищем на ведущих аукционах мира автомобиль под ваш бюджет и требования."},
        {title: "Покупка", text: "Участвуем в торгах от вашего имени и покупаем по лучшей цене."},
        {title: "Транспортировка", text: "Организуем морскую или авиаперевозку и информируем вас на каждом этапе."},
        {title: "Выдача", text: "Терминальные услуги и передача автомобиля в удобном для вас месте."}
      ],
      extras_title: "Дополнительные услуги",
      extras: [
        "Терминальные услуги",
        "Софинансирование",
        "Проверка истории автомобиля",
        "Помощь в продаже",
        "Импорт автозапчастей и аксессуаров",
        "Импорт спецтехники"
      ],
      cta_text: "Напишите или позвоните — проконсультируем и рассчитаем полную стоимость.",
      cta_button: "Связаться с нами"
    },
    contactPage: {
      eyebrow: "Car Auto Import Express",
      title: "Контакты",
      subtitle: "Позвоните, напишите или приезжайте в наш офис — мы всегда рады помочь.",
      form_note: "Заполните форму, и наш менеджер свяжется с вами в рабочее время.",
      channels_title: "Быстрая связь",
      call_button: "Позвонить",
      whatsapp_button: "Написать в WhatsApp",
      email_button: "Отправить письмо",
      open_map: "Открыть на карте"
    }
  },

  am: {
    common: {
      save: "Պահպանել", cancel: "Չեղարկել", close: "Փակել", delete: "Ջնջել",
      edit: "Խմբագրել", view: "Դիտել", confirm: "Հաստատել",
      confirm_title: "Հաստատեք գործողությունը", search: "Որոնում", loading: "Բեռնվում է...",
      saving: "Պահպանվում է...", back: "Ետ", next: "Հաջորդ", previous: "Նախորդ",
      retry: "Կրկին փորձել", clear: "Մաքրել", all: "Բոլորը", yes: "Այո", no: "Ոչ",
      of: "-ից", copy: "Պատճենել", copied: "Հղումը պատճենվեց",
      required_note: "Աստղանիշով դաշտերը պարտադիր են",
      unsaved_changes: "Կան չպահպանված փոփոխություններ։ Լքե՞լ էջը։",
      error_title: "Սխալ է տեղի ունեցել",
      error_message: "Չհաջողվեց բեռնել տվյալները։ Կրկին փորձեք։"
    },
    market: {
      title: "Ավտոմեքենաների շուկա",
      subtitle: "Ընտրեք ձեր ավտոմեքենան մեր առաջարկներից",
      results_found: "Գտնվեց", results_unit: "ավտոմեքենա",
      filters: "Ֆիլտրեր", show_filters: "Ցույց տալ ֆիլտրերը", hide_filters: "Թաքցնել ֆիլտրերը",
      clear_filters: "Մաքրել ֆիլտրերը", apply: "Կիրառել",
      search_placeholder: "Որոնում ըստ մակնիշի, մոդելի կամ VIN-ի",
      brand: "Մակնիշ", model: "Մոդել", year_from: "Տարի-ից", year_to: "Տարի-մինչև",
      price_from: "Գին-ից", price_to: "Գին-մինչև",
      mileage_from: "Վազք-ից", mileage_to: "Վազք-մինչև",
      fuel: "Վառելիք", transmission: "Փոխանցման տուփ", body_type: "Թափքի տեսակ",
      drive: "Քարշակ", location: "Գտնվելու վայրը", status: "Կարգավիճակ",
      status_all: "Բոլորը", status_for_sale: "Վաճառքում", status_sold: "Վաճառված",
      sort: "Դասավորել",
      sort_newest: "Սկզբում նորերը", sort_oldest: "Սկզբում հները",
      sort_price_asc: "Գին՝ աճման կարգով", sort_price_desc: "Գին՝ նվազման կարգով",
      sort_mileage_asc: "Վազք՝ աճման կարգով", sort_mileage_desc: "Վազք՝ նվազման կարգով",
      view_details: "Մանրամասն",
      empty_title: "Ավտոմեքենա չի գտնվել",
      empty_message: "Փոխեք կամ մաքրեք ֆիլտրերը և կրկին փորձեք։",
      loading: "Ավտոմեքենաները բեռնվում են...",
      published: "Ավելացվել է",
      page_of: "Էջ"
    },
    details: {
      back_to_market: "Վերադառնալ շուկա",
      overview: "Ընդհանուր", description: "Նկարագրություն", features: "Հագեցվածություն",
      specifications: "Բնութագրեր", similar_cars: "Նմանատիպ ավտոմեքենաներ",
      contact_seller: "Կապվեք մեզ հետ", request_info: "Հետաքրքրվա՞ծ եք այս մեքենայով",
      request_info_text: "Թողեք ձեր կոնտակտները և մեր մենեջերը կկապվի ձեզ հետ։",
      your_name: "Անուն", your_phone: "Հեռախոս", your_email: "Էլ. փոստ",
      your_message: "Հաղորդագրություն",
      send_request: "Ուղարկել հայտը", sending: "Ուղարկվում է...",
      request_sent: "Ձեր հայտն ընդունված է։ Շուտով կկապվենք ձեզ հետ։",
      call_now: "Զանգահարել", published_at: "Հրապարակվել է", lot: "Լոտի համար",
      auction: "Աճուրդ", currency: "Արժույթ", no_images: "Լուսանկարներ չկան",
      not_found_title: "Ավտոմեքենան չի գտնվել",
      not_found_message: "Այս ավտոմեքենան այլևս հասանելի չէ կամ ջնջվել է։",
      photo_of: "Լուսանկար", open_gallery: "Բացել պատկերասրահը",
      close_gallery: "Փակել պատկերասրահը",
      prev_photo: "Նախորդ լուսանկար", next_photo: "Հաջորդ լուսանկար"
    },
    admin: {
      panel: "Ադմին վահանակ", dashboard: "Գլխավոր", cars: "Ավտոմեքենաներ", leads: "Հայտեր",
      messages: "Հաղորդագրություններ", back_to_site: "Վերադառնալ կայք",
      access_denied_title: "Մուտքը սահմանափակ է",
      access_denied_message: "Այս էջը դիտելու համար անհրաժեշտ է մուտք գործել։",
      login: "Մուտք",
      cars_title: "Ավտոմեքենաների կառավարում",
      cars_subtitle: "Ավելացրեք և խմբագրեք շուկայի ավտոմեքենաները",
      add_car: "Ավելացնել մեքենա", edit_car: "Խմբագրել մեքենան",
      search_cars: "Որոնում ըստ մակնիշի, մոդելի կամ VIN-ի",
      table_photo: "Լուսանկար", table_car: "Ավտոմեքենա", table_vin: "VIN", table_year: "Տարի",
      table_price: "Գին", table_mileage: "Վազք", table_location: "Վայր",
      table_status: "Կարգավիճակ", table_date: "Ամսաթիվ", table_actions: "Գործողություններ",
      mark_as_sold: "Նշել վաճառված", mark_as_for_sale: "Նշել վաճառքում",
      manage_images: "Կառավարել լուսանկարները",
      delete_car_title: "Ջնջել ավտոմեքենան",
      delete_car_message: "Ջնջե՞լ այս ավտոմեքենան։ Գործողությունն անշրջելի է։",
      no_cars_title: "Ավտոմեքենաներ չկան",
      no_cars_message: "Ավելացրեք առաջին ավտոմեքենան։",
      car_created: "Ավտոմեքենան հաջողությամբ ավելացվեց",
      car_updated: "Ավտոմեքենան հաջողությամբ թարմացվեց",
      car_deleted: "Ավտոմեքենան ջնջվեց",
      status_changed: "Կարգավիճակը փոխվեց"
    },
    carForm: {
      step_basic: "Հիմնական տվյալներ", step_technical: "Տեխնիկական բնութագրեր",
      step_price: "Գին և կարգավիճակ", step_description: "Նկարագրություն և հագեցվածություն",
      step_images: "Լուսանկարներ", step_review: "Ստուգում",
      vin: "VIN", vin_hint: "17 նիշ։ Սեղմեք Enter ավտոմատ լրացման համար։",
      decode_vin: "Վերծանել VIN-ը", vin_decoded: "VIN-ի տվյալները բեռնվեցին",
      vin_decode_failed: "Չհաջողվեց վերծանել VIN-ը",
      mark: "Մակնիշ", model: "Մոդել", year: "Թողարկման տարի", lot: "Լոտի համար",
      auction: "Աճուրդ", price: "Գին", currency: "Արժույթ", phone: "Կոնտակտային հեռախոս",
      location: "Գտնվելու վայրը", category: "Թափքի տեսակ", millage: "Վազք (կմ)",
      fuel: "Վառելիքի տեսակ", engine: "Շարժիչի ծավալ", cilinder: "Մխոցներ",
      transmission: "Փոխանցման տուփ", drive: "Քարշակ", doors: "Դռներ",
      airbags: "Անվտանգության բարձիկներ", color: "Գույն",
      description: "Նկարագրություն",
      description_placeholder: "Ավելացրեք լրացուցիչ տեղեկություն մեքենայի մասին",
      features: "Հագեցվածություն", features_placeholder: "Մուտքագրեք և սեղմեք Enter",
      add_feature: "Ավելացնել",
      images: "Լուսանկարներ", choose_files: "Ընտրել լուսանկարներ",
      drop_hint: "JPG, PNG, WEBP կամ AVIF — մինչև 10 ՄԲ յուրաքանչյուրը",
      upload: "Վերբեռնել", uploading: "Վերբեռնվում է...",
      set_cover: "Դարձնել գլխավոր", cover: "Գլխավոր",
      move_left: "Ձախ", move_right: "Աջ", remove_image: "Ջնջել լուսանկարը",
      delete_image_title: "Ջնջել լուսանկարը",
      delete_image_message: "Ջնջե՞լ այս լուսանկարը։",
      images_uploaded: "Լուսանկարները վերբեռնվեցին", image_removed: "Լուսանկարը ջնջվեց",
      gallery_updated: "Պատկերասրահը թարմացվեց",
      pending_images: "Պատրաստ վերբեռնման", saved_images: "Պահպանված լուսանկարներ",
      no_images_yet: "Լուսանկարներ դեռ չկան",
      select_placeholder: "Ընտրեք",
      invalid_type: "Թույլատրվում են միայն JPG, PNG, WEBP, AVIF և GIF",
      too_large: "Ֆայլը 10 ՄԲ-ից մեծ է",
      too_many: "Միանգամից կարող եք վերբեռնել առավելագույնը 30 լուսանկար",
      fix_errors: "Խնդրում ենք լրացնել բոլոր պարտադիր դաշտերը",
      save_car: "Պահպանել", save_and_continue: "Պահպանել և շարունակել", finish: "Ավարտել"
    },
    leads: {
      title: "Հայտեր և դիմումներ",
      subtitle: "Այցելուների ուղարկած դիմումները",
      search_placeholder: "Որոնում ըստ անվան, հեռախոսի կամ էլ. փոստի",
      table_client: "Հաճախորդ", table_contact: "Կոնտակտ", table_source: "Աղբյուր",
      table_car: "Ավտոմեքենա", table_status: "Կարգավիճակ", table_date: "Ամսաթիվ",
      table_actions: "Գործողություններ",
      status_new: "Նոր", status_contacted: "Կապ հաստատված", status_qualified: "Որակավորված",
      status_closed: "Փակված", status_rejected: "Մերժված",
      source_home_form: "Գլխավոր էջ", source_contact_form: "Կոնտակտի ձև",
      source_car_enquiry: "Մեքենայի հարցում", source_callback: "Հետ զանգ",
      source_subscribe: "Բաժանորդագրություն", source_other: "Այլ",
      filter_status: "Կարգավիճակ", filter_source: "Աղբյուր",
      filter_date_from: "Ամսաթիվ-ից", filter_date_to: "Ամսաթիվ-մինչև",
      details_title: "Հայտի մանրամասներ",
      client_type: "Հաճախորդի տեսակ", est_amount: "Մոտավոր բյուջե",
      manufacturer: "Ցանկալի մակնիշ", message: "Հաղորդագրություն", subject: "Թեմա",
      admin_note: "Ներքին նշում", admin_note_placeholder: "Ավելացրեք նշում այս հայտի մասին",
      save_note: "Պահպանել նշումը", change_status: "Փոխել կարգավիճակը",
      open_car: "Բացել մեքենան", created_at: "Ստեղծվել է", updated_at: "Թարմացվել է",
      no_leads_title: "Հայտեր դեռ չկան",
      no_leads_message: "Նոր դիմումները կհայտնվեն այստեղ։",
      delete_title: "Ջնջել հայտը",
      delete_message: "Ջնջե՞լ այս հայտը։ Գործողությունն անշրջելի է։",
      status_updated: "Կարգավիճակը թարմացվեց", note_updated: "Նշումը պահպանվեց",
      lead_deleted: "Հայտը ջնջվեց"
    },
    home_page: {
      about_us_title: "Carexpress-ի մասին",
      latest_cars: "Վերջին ավտոմեքենաները",
      latest_cars_subtitle: "Մեր շուկայում արդեն հասանելի ավտոմեքենաներ",
      view_all_cars: "Բոլոր ավտոմեքենաները",
      hero: {
        title_line1: "Ընտրեք ձեր",
        title_accent: "ավտոմեքենան",
        subtitle: "Մենք կգտնենք, կստուգենք և կբերենք ձեր ուզած ավտոմեքենան ԱՄՆ-ից, Կանադայից և Եվրոպայից",
        feature_experience: "20+ տարվա փորձ",
        feature_imported: "15,000+ հաջողությամբ բերված ավտոմեքենա",
        feature_history: "Յուրաքանչյուր ստուգվող մեքենայի ամբողջական պատմություն",
        feature_support: "Ամբողջական աջակցություն աճուրդից մինչև գրանցում",
        view_cars: "Դիտել ավտոմեքենաները",
        form_title: "Լրացրեք հայտը",
        form_subtitle: "Մեր մասնագետը շուտով կկապվի ձեզ հետ",
        purpose_label: "Ի՞նչ նպատակով եք ցանկանում բերել ավտոմեքենա",
        purpose_personal: "Անձնական օգտագործման համար",
        purpose_dealer: "Ես դիլեր եմ",
        price_label: "Ի՞նչ գնային կատեգորիայում եք փնտրում ավտոմեքենա",
        price_3_full: "$18,000-ից ավելի",
        price_3_short: "$18K+",
        make_label: "Ո՞ր մակնիշի ավտոմեքենան է ձեզ հետաքրքրում",
        make_placeholder: "Ընտրեք մակնիշը",
        ph_name: "Անուն",
        ph_surname: "Ազգանուն",
        ph_phone: "Հեռ. համար",
        ph_email: "Էլ. փոստ",
        ph_comment: "Մեկնաբանություն",
        agree: "Համաձայն եմ անձնական տվյալների մշակմանը",
        submit: "Ուղարկել",
        submitting: "Ուղարկվում է...",
        agree_required: "Խնդրում ենք հաստատել անձնական տվյալների մշակման համաձայնությունը",
        request_sent: "Ձեր հայտն ուղարկվեց",
        request_failed: "Սխալ տեղի ունեցավ։ Կրկին փորձեք։"
      }
    },
    about: {
      eyebrow: "Car Auto Import Express",
      title: "Մեր մասին",
      subtitle: "Ավելի քան 20 տարի ներմուծում ենք ավտոմեքենաներ, հատուկ տեխնիկա և ավտոմասեր ԱՄՆ-ից, Կանադայից և Եվրոպայից։",
      stats: [
        {value: "20+", label: "տարի շուկայում"},
        {value: "200 000+", label: "ներմուծված ավտոմեքենա"},
        {value: "30", label: "մասնաճյուղ Վրաստանում"},
        {value: "10", label: "ներկայացուցչություն արտերկրում"}
      ],
      story_title: "Ովքե՞ր ենք մենք",
      offers_title: "Ի՞նչ ենք առաջարկում",
      market_title: "Մեր ավտոմարկետը",
      vehicles_title: "Ի՞նչ ենք փոխադրում",
      offers: [
        "Անսահմանափակ ընտրություն աշխարհի առաջատար աճուրդներից և դիլերական հարթակներից",
        "Ավտոմեքենայի գնում լավագույն գնով",
        "Ապահով և արագ տեղափոխում",
        "Ճկուն և անհատականացված համաֆինանսավորում",
        "Պատասխանատվություն մեքենայի վնասների համար",
        "Առաքում գնման վայրից մինչև ձեր ընտրած հասցեն",
        "Օգնություն մեքենայի վերավաճառքում",
        "Տերմինալային ծառայություններ"
      ],
      cta_title: "Պատրա՞ստ եք ներմուծել ձեր մեքենան",
      cta_text: "Կապվեք մեզ հետ, և մեր մենեջերը կօգնի ընտրել ճիշտ ավտոմեքենան։",
      cta_button: "Կապվել մեզ հետ",
      browse_cars: "Դիտել ավտոմեքենաները"
    },
    services: {
      eyebrow: "Car Auto Import Express",
      subtitle: "Ծովային, օդային և հատուկ փոխադրումներ՝ մեկ թիմ աճուրդից մինչև ձեր բակը։",
      sea_description: "Կոնտեյներային և RoRo փոխադրումներ ԱՄՆ-ի, Կանադայի և Եվրոպայի նավահանգիստներից։",
      air_description: "Շտապ ավիափոխադրում, երբ մեքենան կամ պահեստամասերն արագ են պետք։",
      yacht_description: "Յախտերի, նավակների և ջրային տրանսպորտի ապահով փոխադրում։",
      process_title: "Ինչպես է աշխատում",
      steps: [
        {title: "Ընտրություն", text: "Աշխարհի առաջատար աճուրդներում փնտրում ենք ձեր բյուջեին համապատասխան մեքենա։"},
        {title: "Գնում", text: "Մասնակցում ենք աճուրդին ձեր անունից և գնում լավագույն գնով։"},
        {title: "Փոխադրում", text: "Կազմակերպում ենք ծովային կամ օդային փոխադրումը և տեղեկացնում յուրաքանչյուր փուլի մասին։"},
        {title: "Հանձնում", text: "Տերմինալային ծառայություններ և մեքենայի հանձնում ձեր ընտրած վայրում։"}
      ],
      extras_title: "Լրացուցիչ ծառայություններ",
      extras: [
        "Տերմինալային ծառայություններ",
        "Համաֆինանսավորում",
        "Մեքենայի պատմության ստուգում",
        "Օգնություն վերավաճառքում",
        "Ավտոմասերի և աքսեսուարների ներմուծում",
        "Հատուկ տեխնիկայի ներմուծում"
      ],
      cta_text: "Գրեք կամ զանգահարեք — կխորհրդատվենք և կհաշվարկենք ամբողջ արժեքը։",
      cta_button: "Կապվել մեզ հետ"
    },
    contactPage: {
      eyebrow: "Car Auto Import Express",
      title: "Կապ",
      subtitle: "Զանգահարեք, գրեք կամ այցելեք մեր գրասենյակ — մենք միշտ պատրաստ ենք օգնել։",
      form_note: "Լրացրեք ձևը, և մեր մենեջերը կկապվի ձեզ հետ աշխատանքային ժամերին։",
      channels_title: "Արագ կապ",
      call_button: "Զանգահարել",
      whatsapp_button: "Գրել WhatsApp-ով",
      email_button: "Ուղարկել նամակ",
      open_map: "Բացել քարտեզում"
    }
  }
};

export default languageExtra;
